import { render, staticRenderFns } from "./HistorialEmergenciaPage.vue?vue&type=template&id=83702ef8&scoped=true&"
import script from "./HistorialEmergenciaPage.vue?vue&type=script&lang=js&"
export * from "./HistorialEmergenciaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83702ef8",
  null
  
)

export default component.exports